import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-folder-view',
  templateUrl: './folder-view.component.html',
  styleUrls: ['./folder-view.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class FolderViewComponent {
  creativeData = [
    {
      image:'https://gw.alipayobjects.com/zos/rmsportal/JiqGstEfoWAOHiTxclqi.png',
      status:'active',
      adsType:'video',
      value:'77.81'
    },{
      image:'https://gw.alipayobjects.com/zos/rmsportal/JiqGstEfoWAOHiTxclqi.png',
      status:'active',
      adsType:'image',
      value:'77.82'
    },{
      image:'https://gw.alipayobjects.com/zos/rmsportal/JiqGstEfoWAOHiTxclqi.png',
      status:'inactive',
      adsType:'video',
      value:'77.83'
    },{
      image:'https://gw.alipayobjects.com/zos/rmsportal/JiqGstEfoWAOHiTxclqi.png',
      status:'warning',
      adsType:'image',
      value:'77.84'
    }
    ,{
      image:'https://gw.alipayobjects.com/zos/rmsportal/JiqGstEfoWAOHiTxclqi.png',
      status:'active',
      adsType:'video',
      value:'77.85'
    },{
      image:'https://gw.alipayobjects.com/zos/rmsportal/JiqGstEfoWAOHiTxclqi.png',
      status:'active',
      adsType:'image',
      value:'77.86'
    },{
      image:'https://gw.alipayobjects.com/zos/rmsportal/JiqGstEfoWAOHiTxclqi.png',
      status:'inactive',
      adsType:'video',
      value:'77.87'
    },{
      image:'https://gw.alipayobjects.com/zos/rmsportal/JiqGstEfoWAOHiTxclqi.png',
      status:'warning',
      adsType:'image',
      value:'77.88'
    },{
      image:'https://gw.alipayobjects.com/zos/rmsportal/JiqGstEfoWAOHiTxclqi.png',
      status:'active',
      adsType:'video',
      value:'77.89'
    },{
      image:'https://gw.alipayobjects.com/zos/rmsportal/JiqGstEfoWAOHiTxclqi.png',
      status:'active',
      adsType:'image',
      value:'77.90'
    },{
      image:'https://gw.alipayobjects.com/zos/rmsportal/JiqGstEfoWAOHiTxclqi.png',
      status:'inactive',
      adsType:'video',
      value:'77.91'
    },{
      image:'https://gw.alipayobjects.com/zos/rmsportal/JiqGstEfoWAOHiTxclqi.png',
      status:'warning',
      adsType:'image',
      value:'77.92'
    }

  ];
}
